export default {
  featuredExperiences: 'Våra utvalda upplevelser',
  searchAllExperiences: 'Sök alla upplevelser',
  searchAll: 'Sök alla',
  groupSize: 'Gruppstorlek',
  eventSize: 'Evenemangsstorlek',
  upTo: 'Upp till',
  whatWeDo: 'Vad vi kommer att göra',
  hostedBy: 'Värd',
  whatsIncluded: 'Vad som ingår',
  avail: 'Tillgänglighet',
  whereWeAre: 'Var vi kommer att vara',
  experienceCalendar: 'Upplevelsekalender',
  experienceCancelled: 'Upplevelse avbokad',
  experienceStartingPrice: 'Från {{price}}',
  experienceTotalPrice: 'Totalt {{price}}',
  at: 'kl',
  viewPrivateSessAvailability: 'Visa tillgänglighet för privat session',
  selectDuration: 'Längd',
  selectStartTime: 'Starttid',
  selectSession: 'Välj session',
  sessionsCount: '{{count}} tider — välj en tid',
  noAvailability: 'Ingen tillgänglighet',
  select: 'Välj',
  slotLeft: '{{remainSlots}} plats kvar',
  slotsLeft: '{{remainSlots}} platser kvar',
  spotsLeft: '{{count}} kvar',
  spotsLeftAriaLabel: '{{count}} platser kvar',
  bookExperience: 'Boka upplevelse',
  book: 'Boka',
  learnMore: 'Läs mer',
  apply: 'Tillämpa',
  maxPartySizes: 'Maximalt {{maxGroupSize}} platser per sällskap',
  maxPartySize: 'Maximalt {{maxGroupSize}} plats per sällskap',
  selectSessionValidation: 'Vänligen välj session',
  selectParticipantValidation: 'Vänligen välj deltagare',
  selectDateValidation: 'Vänligen välj datum',
  reminders: 'Påminnelser',
  seeOtherDates: 'Se andra datum',
  location: 'Plats',
  about: 'Om',
  allExperiences: 'Alla upplevelser',
  soldOut: 'Slutsåld',
  addOns: 'Tillägg',
  reviews: 'Recensioner',
  reviewSingular: 'recension',
  reviewPlural: 'recensioner',
  dateOfExperience: 'Upplevelsedatum',
  readLess: 'Läs mindre',
  readMore: 'Läs mer',
  seeMore: 'Se mer',
  details: 'Detaljer',
  durationHour: 'timme',
  durationHours: 'timmar',
  durationMinutes: 'min',
  theFollowingVideoDoesNotContainAnyAudio:
    'Följande video innehåller inget ljud',
  by: 'Av',
  chooseATime: 'Välj en tid för {{title}}',
  amenities: 'Bekvämligheter',
  ticketSalesOpenIn: 'Biljettförsäljningen öppnar om',
  ticketSalesOpen: 'Biljettförsäljningen öppnar',
  ticketSalesCloseIn: 'Biljettförsäljningen stänger om',
  ticketSalesClose: 'Biljettförsäljningen stänger',
  ticketSalesClosed: 'Biljettförsäljningen stängd',
  comingSoon: 'Kommer snart',
  inPartnershipWith: 'I samarbete med',
  notFoundExperienceTitle: 'Denna upplevelse är inte längre tillgänglig',
  notFoundExperienceSubtitle:
    'Den kan ha avpublicerats, eller länken är inte längre giltig.',
  deadLinkRecoverySubtitle: 'Upptäck andra upplevelser som går att boka',
  viewAllExperiences: 'Visa alla upplevelser',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Tjäna 5 baspoäng</strong> per kvalificerad $1 USD spenderad när du loggar in på ditt World of Hyatt-konto för att boka denna upplevelse</p>',
      basePoints:
        '<p><strong>Tjäna 10 baspoäng</strong> per kvalificerad $1 USD spenderad när du loggar in på ditt World of Hyatt-konto för att boka denna upplevelse</p>',
      additionalBonusPoints:
        '<p><strong>Tjäna ytterligare 4 bonuspoäng</strong> per kvalificerad $1 USD spenderad när du bokar med ditt World of Hyatt-kreditkort</p>',
      additionalBonusPointsTier:
        '<p><strong>Tjäna upp till 30% ytterligare bonuspoäng</strong> beroende på din nivåstatus</p>',
      payWithPoints:
        '<p><strong>Betala med poäng</strong> när du bokar denna upplevelse</p>',
    },
  },
};
